module.exports = __webpack_public_path__ + "static/img/生物制造.41613e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/研究领域banner/生物制造.jpg
// module id = 28co
// module chunks = 16